// IMPORT NODE MODULES
import Vue from 'vue'
import VueRouter from 'vue-router'
import VDoctitle from 'vue-doctitle'
import VueResource from 'vue-resource'
import Sortable from 'vue-sortable'
import ac from 'accounting'
import VueValidator from 'vue-validator'
import ES6Promise from 'es6-promise'
import VueLazyload from 'vue-lazyload'

ES6Promise.polyfill()
// import nl from './assets/js/nl.js'
import store from './store'

// IMPORT ASSETS
import '../node_modules/font-awesome/css/font-awesome.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/bootstrap/dist/js/bootstrap.js'
import './assets/style.css'
import './assets/flickity.css'
import 'drift-zoom/dist/drift-basic.css'
// Externals
import $ from 'jquery'
window.$ = $
window.jQuery = $

// IMPORT PAGES
import App from './App'
import Hello from './components/Hello'
import Contact from './components/Contact'
import Gastenboek from './components/Gastenboek'
import About from './components/About'
import Product from './components/Product'
import Category from './components/Categorie'
import Login from './components/login'
import Order from './components/ordering/order'
import Search from './components/Search'
// import Opening from './components/opening'

// IMPORT CUSTOMERSERVICES
import algemeneVoorwaarden from './components/customerService/algemeneVoorwaarden'
import giftService from './components/customerService/giftService'
import paying from './components/customerService/paying'
import shipping from './components/customerService/shipping'

// after-ordening
import betalen from './components/afterordening/betalen'
import bevestiging from './components/afterordening/betaling-succesvol'
import annulering from './components/afterordening/betaling-geannuleerd'

// IMPORT ADMIN PAGES
import Dashboard from './components/dashboard/dashboard'
import AddProduct from './components/dashboard/addProduct'
import AddRubrics from './components/dashboard/addEditRubrics'
import adminconfig from './components/dashboard/adminconfig'
import admingastenboek from './components/dashboard/guestbook'
import adminorders from './components/dashboard/order-overzicht'
import adminanalytics from './components/dashboard/analytics'

// SETUP VUE-ROUTER
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VDoctitle)
Vue.use(Sortable)
Vue.use(VueValidator)
Vue.use(VueLazyload, {loading: './assets/img/ajax_loader.gif'})

Vue.directive('echarts', require('./directives/echarts'))

// FILTERS
Vue.filter('currencyDisplay', {
  // model -> view
  read: function (val) {
    return ac.formatMoney(val, '€ ', 2, '.', ',')
  },
  // view -> model
  write: function (val, oldVal) {
    return ac.unformat(val, ',')
  }
})

function generateSlug (value) {
  // 1) convert to lowercase
  // 2) remove dashes and pluses
  // 3) replace spaces with dashes
  // 4) remove everything but alphanumeric characters and dashes
  return value.toLowerCase().replace(/-+/g, '').replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
}

Vue.filter('slugurl', generateSlug)

// Validators
Vue.validator('email', function (val) {
  return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(val)
})

Vue.validator('dutchzip', function (val) {
  return /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(val)
})

Vue.validator('housenumber', function (val) {
  return /^\d+[a-zA-Z]*$/.test(val)
})
// ROUTER
export var router = new VueRouter({
  hashbang: false,
  history: true,
  mode: 'html5',
  linkActiveClass: 'active' // When the navigation is clicked, set button class to 'active' for styling purposes.
})

VDoctitle.wrap(router, { defTitle: 'Catootjes kraam', filter: function (title) { return 'Catootjes kraam - ' + title } })

router.map({
  '/': {
    name: 'Welkom',
    component: Hello,
    doctitle: 'Welkom'
  },
  '/index': {
    name: 'Welkom',
    component: Hello,
    doctitle: 'Welkom'
  },
  '/klantenservice/contact': {
    name: 'Contact',
    component: Contact,
    doctitle: 'Contact'
  },
  '/gastenboek': {
    name: 'Gastenboek',
    component: Gastenboek,
    doctitle: 'Gastenboek'

  },
  'over-ons': {
    name: 'about-us',
    component: About,
    doctitle: 'Over Ons'
  },
  '/categorie/:id/:cname': {
    name: 'categorie',
    component: Category
  },
  '/product/:id/:pname': {
    name: 'Product',
    component: Product
  },
    // Customer Service
  '/klantenservice/algemene-voorwaarden': {
    name: 'algemeneVoorwaarden',
    component: algemeneVoorwaarden,
    doctitle: 'Algemene Voorwaarden'
  },
  '/klantenservice/kado-service': {
    name: 'giftService',
    component: giftService,
    doctitle: 'Kado Service'
  },
  '/klantenservice/betaling': {
    name: 'paying',
    component: paying,
    doctitle: 'Betaling'
  },
  '/klantenservice/verzenden-en-ophalen': {
    name: 'shipping',
    component: shipping,
    doctitle: 'Verzenden en Ophalen'
  },
  '/login': {
    name: 'Login',
    component: Login
  },
  '/bestelling': {
    name: 'order',
    component: Order
  },
  '/search/:term': {
    name: 'Search',
    component: Search
  },
  '/betalen/:burl': {
    name: 'Betalen',
    component: betalen
  },
  '/bevestiging/:burl/:date': {
    name: 'Bevestiging',
    component: bevestiging
  },
  '/annulering': {
    name: 'Annulering',
    component: annulering
  },
  // ADMIN PANEL
  '/dashboard': {
    name: 'Dashboard',
    component: Dashboard,
    auth: true,
    doctitle: 'Dashboard'
  },
  '/addProduct': {
    name: 'AddProduct',
    component: AddProduct,
    auth: true,
    doctitle: 'Nieuw Product'
  },
  '/addProduct/:id': {
    name: 'AddProduct',
    component: AddProduct,
    auth: true,
    doctitle: 'Product Aanpassen'
  },
  '/addRubrics': {
    name: 'addRubrics',
    component: AddRubrics,
    auth: true,
    doctitle: 'Nieuw Rubriek'
  },
  '/banner': {
    name: 'banner',
    component: adminconfig,
    auth: true,
    doctitle: 'Banner'
  },
  '/admin-gastenboek': {
    name: 'admin-gastenboek',
    component: admingastenboek,
    auth: true,
    doctitle: 'Gastenboek goedkeuren'
  },
  '/admin-order-overzicht': {
    name: 'admin-order-overzicht',
    component: adminorders,
    auth: true,
    doctitle: 'Overzicht orders'
  },
  '/admin-gebruikers-overzicht': {
    name: 'admin-gebruikers-overzicht',
    component: adminanalytics,
    auth: true,
    doctitle: 'Overzicht Gebruikers'
  }
})

router.beforeEach(function (transition) {
  window.scrollTo(0, 0)
  var isAuthenticated = store.isLoggedIn()
  if (transition.to.auth && !isAuthenticated) {
    transition.redirect('/login?path=' + transition.to.path)
  } else {
    transition.next()
  }
})

router.start(App, 'app')



// WEBPACK FOOTER //
// ./src/main.js